import { render } from "./NotionContainer.vue?vue&type=template&id=7f5b4948"
import script from "./NotionContainer.vue?vue&type=script&lang=js"
export * from "./NotionContainer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__